export default __webpack_public_path__ + "static/media/upload_xls_icon.2eb72eff.svg";